import { joinPaths, createURLDescriptor } from './URLTools';
import { NotFoundError } from './Errors';
import { Status } from './Resolver';
export var SegmentType;

(function (SegmentType) {
  SegmentType["Placeholder"] = "placeholder";
  SegmentType["Switch"] = "switch";
  SegmentType["Page"] = "page";
  SegmentType["Redirect"] = "redirect";
})(SegmentType || (SegmentType = {}));

export function isSegmentSteady(segment) {
  return segment.status !== Status.Busy && (segment.remainingSegments.length === 0 || isSegmentSteady(segment.remainingSegments[0]));
}
export function createSegment(type, env, details, ensureTrailingSlash) {
  if (ensureTrailingSlash === void 0) {
    ensureTrailingSlash = true;
  }

  return Object.assign({
    type: type,
    meta: undefined,
    params: env.params,
    url: createURLDescriptor({
      pathname: env.pathname,
      query: env.query
    }, {
      ensureTrailingSlash: ensureTrailingSlash
    }),
    remainingSegments: details.remainingSegments || []
  }, details);
}
export function createPlaceholderSegment(env, error, ensureTrailingSlash) {
  if (ensureTrailingSlash === void 0) {
    ensureTrailingSlash = true;
  }

  return createSegment(SegmentType.Placeholder, env, {
    status: error ? Status.Error : Status.Busy,
    error: error
  }, ensureTrailingSlash);
}
export function createNotFoundSegment(env) {
  var fullPathname = joinPaths(env.pathname, env.unmatchedPathnamePart);
  var error = new NotFoundError(fullPathname);
  return {
    type: SegmentType.Placeholder,
    params: env.params,
    url: createURLDescriptor({
      pathname: fullPathname,
      query: env.query
    }),
    status: Status.Error,
    error: error,
    remainingSegments: []
  };
}